











































import { Component } from 'vue-property-decorator';
import vSelect from 'vue-select';
import { CheckIcon, CircleIcon, DiscIcon, InfoIcon } from 'vue-feather-icons';
import { BaseMixin } from '@/mixins/BaseMixin';
import { mixins } from 'vue-class-component';
import { UserApi } from '@/services/UserApi';
import ChangePasswordForm from '@/views/pages/auth/ChangePasswordForm.vue';
import { FormMixin } from '@/mixins/FormMixin';
import FormSubmit from '@/components/common/forms/FormSubmit.vue';

export type ChangePasswordModel = {
  oldpassword: string;
  newpassword: string;
  newpasswordConfirm: string;
};

@Component({
  components: {
    FormSubmit,
    ChangePasswordForm,
    vSelect,
    CircleIcon,
    DiscIcon,
    InfoIcon,
    CheckIcon,
  },
})
export default class ChangePasswordSettings extends mixins(BaseMixin, FormMixin) {
  model = this.defaultModel();
  success = '';

  defaultModel(): ChangePasswordModel {
    return {
      oldpassword: '',
      newpassword: '',
      newpasswordConfirm: '',
    };
  }

  mounted() {
    this.resetErrors();
  }

  async handleSubmit(evt: Event) {
    evt.preventDefault();
    this.resetErrors();

    try {
      this.isLoading = true;
      await UserApi.changePassword({
        oldpassword: this.model.oldpassword,
        newpassword: this.model.newpassword,
        newpasswordConfirm: this.model.newpasswordConfirm,
      });
      this.success = 'Passwort erfolgreich geändert.';
      this.model = this.defaultModel();
    } catch (e) {
      const apiErrors = this.exceptionErrors(e);

      this.addError(
        apiErrors['oldpasswordisNotEmpty'] || apiErrors['LoginIncorrectPassword'],
        'oldpassword',
        'Das alte Passwort ist nicht korrekt.',
      );

      this.addError(
        apiErrors['newpasswordisNotEmpty'] ||
          apiErrors['newpasswordminLength'] ||
          apiErrors['PasswordPolicy'],
        'newpassword',
        'Bitte beachte, dass das Passwort mindestens 8 Zeichen, ein Sonderzeichen und eine Zahl beinhalten muss.',
      );

      this.addError(
        apiErrors['newpasswordConfirmisNotEmpty'] || apiErrors['newpasswordConfirmminLength'],
        'newpasswordConfirm',
        'Die Passwortbestätigung muss übereinstimmen.',
      );

      throw e;
    } finally {
      this.isLoading = false;
    }
  }

  handleReset() {
    this.success = '';
  }
}
